import { lazy, Suspense } from "react";
import { useLocation } from "wouter";
import { useResourcesEnabled } from "@client/hooks/use-resources-enabled";
import { NotFoundCard } from "@client/components/utils/NotFoundCard";
import { Page } from "@client/components/utils/Page";
import { Skeleton } from "@sfc/ui";

// Do not fetch the draft content chunk until the flag permits this viewer.
const ResourcesPage = lazy(async () => ({
  default: (await import("./ResourcesPage")).ResourcesPage,
}));

function ResourcesLoading() {
  return (
    <Page spacing="compact">
      <div role="status" aria-label="Loading page" className="space-y-6">
        <Skeleton className="h-9 w-64 max-w-full" />
        <Skeleton className="h-5 w-full max-w-lg" />
        <Skeleton className="h-72 w-full" />
      </div>
    </Page>
  );
}

export function ResourcesNotFound() {
  const [location] = useLocation();
  return (
    <Page title="Page not found" spacing="compact">
      <title>Page not found · S-Process</title>
      <NotFoundCard
        currentPath={location}
        primaryHref="/"
        primaryLabel="Go to homepage"
      />
    </Page>
  );
}

export function ResourcesRoute() {
  const enabled = useResourcesEnabled();

  if (enabled === undefined) {
    return <ResourcesLoading />;
  }

  if (!enabled) {
    return <ResourcesNotFound />;
  }

  return (
    <Suspense fallback={<ResourcesLoading />}>
      <ResourcesPage />
    </Suspense>
  );
}
